import { throttle } from "lodash/function"
import { find } from "lodash/collection"
import { dispatch } from "../Dispatcher"

// NOTE!! these should be kept normalised with the breakpoints in _settings.scss
const breakpoints = [
  { name: "small", min: 0 },
  { name: "medium", min: 512 },
  { name: "large", min: 768 },
  { name: "xlarge", min: 1024 },
  { name: "xxlarge", min: 1200 }
]

const serverSize = "large"

function canUseDom() {
  return !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  )
}

export function width() {
  return canUseDom() ? document.body.getBoundingClientRect().width : undefined
}

export function getCurrentBreakpoint() {
  if (!canUseDom()) {
    return _.find(breakpoints, ["name", serverSize])
  }

  const w = width()

  const breakpoint = breakpoints.reduce(
    (result, breakpoint) => {
      if (w >= breakpoint.min) {
        if (!result.min || result.min < breakpoint.min) result = breakpoint
      }
      return result
    },
    { min: null }
  )

  return breakpoint
}

//returns true if current breakpoint is equal to passed param, or larger
export function isSizeGreaterOrEqual(size) {
  const sizeBreakpoint = find(breakpoints, ["name", size])
  const windowBreakpoint = getCurrentBreakpoint()

  return windowBreakpoint.min >= sizeBreakpoint.min
}

export function windowSizeListen() {
  window.addEventListener(
    "resize",
    throttle(() => {
      const breakpoint = getCurrentBreakpoint()

      dispatch({ type: "view-size", data: breakpoint })
    }, 800),
    { passive: true }
  )
}



// WEBPACK FOOTER //
// ./webapp/scripts/size.js